/**
 * Prototype UI — replace with Medplum hooks later.
 */

export type AcknowledgmentStatus = 'accepted' | 'rejected';

export interface AcknowledgmentRow {
  id: string;
  claimId: string;
  clientName: string;
  payer: string;
  status: AcknowledgmentStatus;
  receivedAt: string;
  rejectionCodes: string[];
  disposition: string;
}

export const MOCK_ACKNOWLEDGMENTS: AcknowledgmentRow[] = [];

export function findAcknowledgmentById(id: string | undefined): AcknowledgmentRow | undefined {
  if (!id) return undefined;
  return MOCK_ACKNOWLEDGMENTS.find((r) => r.id === id);
}
